import { Component, inject } from '@angular/core';
import { AppDeepLinkService } from '../../core/services/app-deep-link.service';

@Component({
  selector: 'app-open-in-app-banner',
  standalone: true,
  templateUrl: './open-in-app-banner.component.html',
  styleUrl: './open-in-app-banner.component.scss',
})
export class OpenInAppBannerComponent {
  private readonly deepLink = inject(AppDeepLinkService);

  readonly visible = this.deepLink.appNotFound;

  openApp(): void {
    this.deepLink.retry();
  }

  dismiss(): void {
    this.deepLink.dismiss();
  }
}
